import { DialogTitle, DialogContent, Typography } from "@mui/material";
import { CommonDialog } from "@/components/common/CommonDialog";
import { FormButtonGroup } from "@/components/form";

interface GoogleRevokeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenPermissionsPage: () => void;
}

/**
 * Modal para orientar o usuário a revogar permissões do Google manualmente.
 * Utiliza CommonDialog e FormButtonGroup para padronização visual.
 */
export function GoogleRevokeDialog({ isOpen, onClose, onOpenPermissionsPage }: GoogleRevokeDialogProps) {
  return (
    <CommonDialog isOpen={isOpen} handleClose={onClose}>
      <DialogTitle>Remover permissões do Google</DialogTitle>
      <DialogContent>
        <Typography>
          Para remover completamente as permissões do Google Calendar, acesse a página de permissões do Google e remova o aplicativo Fluxmed manualmente.
        </Typography>
      </DialogContent>
      <FormButtonGroup
        onGoBackButtonClick={onClose}
        onNextButtonClick={onOpenPermissionsPage}
        goBackButtonText="Fechar"
        nextButtonText="Abrir página de permissões"
      />
    </CommonDialog>
  );
} 